import axios from "axios";
import { HttpError } from "@refinedev/core";

const fnlAPI = axios.create({
  withCredentials: false,
});

fnlAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    const customError: HttpError = {
      ...error,
      message: error.response?.data,
      statusCode: error.response?.status,
      errorBody: error.response?.data,
    };

    if (error.code === "ERR_NETWORK") {
      return Promise.reject({ message: "Отсутствует подключение к серверу" });
    }

    return Promise.reject(customError);
  }
);

export default fnlAPI;
